/* ==========================================================================
   XRED · Serious theme · cart drawer
   The static build's cart behaviour on Shopify's cart. Opens from any
   [data-cart-open] and after every add (xred:cart:added). Every change posts
   to Shopify with sections=cart-drawer and the drawer re-renders from the
   section's own HTML (the .cart__panel is swapped), so totals, discounts and
   the header count are never guessed. Pickup and the gift note are cart
   attributes (attributes[Pickup], attributes[Gift note]); the order note is
   cart.note. Loaded only when the cart type is "drawer".
   ========================================================================== */
(function () {
  'use strict';
  var H = window.XRED || { routes: {}, strings: {} };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function say(msg) { if (H.toast) H.toast(msg || H.strings.cartError || 'Something went wrong'); }

  function boot() {
    var drawer = $('#CartDrawer');
    if (!drawer || drawer.__xrBoot) return;
    drawer.__xrBoot = true;
    var lastFocus = null, busy = false;

    function paintShip() {
      // The free-shipping fill animates from 0 on every render (the swap
      // replaces the element, so the CSS transition has something to do).
      var fill = $('.ship__fill', drawer); if (!fill) return;
      var p = Math.max(0, Math.min(1, parseFloat(fill.dataset.ship) || 0));
      requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.transform = 'scaleX(' + p.toFixed(3) + ')'; }); });
    }

    function open() {
      if (!drawer.hidden) return;
      lastFocus = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('cart--open'); }); });
      document.body.classList.add('menu-locked');
      paintShip();
      var c = $('.cart__close', drawer); if (c) c.focus();
    }
    function close() {
      if (drawer.hidden) return;
      drawer.classList.remove('cart--open');
      document.body.classList.remove('menu-locked');
      setTimeout(function () { drawer.hidden = true; }, reduce ? 0 : 320);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function swap(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('#CartDrawer .cart__panel');
      var panel = $('.cart__panel', drawer);
      if (!fresh || !panel) return;
      var active = document.activeElement, keepId = active && drawer.contains(active) ? active.id : '';
      panel.innerHTML = fresh.innerHTML;
      paintShip();
      if (keepId) { var again = $('#' + keepId, drawer); if (again) { again.focus(); if (again.setSelectionRange && again.value) { var n = again.value.length; try { again.setSelectionRange(n, n); } catch (x) {} } } }
      var total = $('[data-cart-count-src]', drawer);
      if (total && H.setCartCount) H.setCartCount(total.dataset.cartCountSrc);
    }

    function refresh(cb) {
      fetch((H.routes.root || '/') + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (j['cart-drawer']) swap(j['cart-drawer']); if (cb) cb(); })
        .catch(function () { if (cb) cb(); });
    }

    function post(url, payload, opts) {
      opts = opts || {};
      if (busy && !opts.force) return Promise.resolve();
      busy = true; drawer.classList.add('is-loading');
      payload.sections = 'cart-drawer';
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) { say(res.body && (res.body.description || res.body.message)); refresh(); return; }
          if (res.body.sections && res.body.sections['cart-drawer']) swap(res.body.sections['cart-drawer']);
          if (H.setCartCount && typeof res.body.item_count === 'number') H.setCartCount(res.body.item_count);
        })
        .catch(function () { say(); })
        .then(function () { busy = false; drawer.classList.remove('is-loading'); });
    }
    function change(line, qty) { return post(H.routes.cartChange || '/cart/change.js', { line: line, quantity: Math.max(0, qty) }); }
    function update(payload) { return post(H.routes.cartUpdate || '/cart/update.js', payload, { force: true }); }

    document.addEventListener('click', function (e) {
      if (!document.contains(drawer)) return;
      var opener = e.target.closest('[data-cart-open]');
      if (opener) { e.preventDefault(); refresh(); open(); return; }
      if (!drawer.contains(e.target)) return;
      if (e.target.closest('[data-cart-close]')) { if (!e.target.closest('a[href]')) e.preventDefault(); close(); return; }
      var step = e.target.closest('[data-step]');
      if (step) {
        var out = $('output', step.parentElement);
        var cur = parseInt(out && out.textContent || '1', 10) || 1;
        change(parseInt(step.dataset.line, 10), cur + (step.dataset.step === '-' ? -1 : 1));
        return;
      }
      var rm = e.target.closest('[data-remove]');
      if (rm) { change(parseInt(rm.dataset.line, 10), 0); }
    });

    drawer.addEventListener('change', function (e) {
      var t = e.target;
      var toggle = t.closest('[data-note-toggle]');
      if (toggle) {
        var box = $('[data-note="' + toggle.dataset.noteToggle + '"]', drawer);
        if (box) { box.hidden = !toggle.checked; var ta = $('textarea', box); if (toggle.checked && ta) ta.focus(); else if (ta && ta.value) { ta.value = ''; ta.dispatchEvent(new Event('input', { bubbles: true })); } }
        return;
      }
      if (t.matches('input[type="checkbox"][data-cart-attr]')) {
        var attrs = {}; attrs[t.dataset.cartAttr] = t.checked ? (t.value || 'Yes') : '';
        update({ attributes: attrs });
      }
    });

    var saveText = debounce(function (t) {
      if (t.hasAttribute('data-cart-note')) update({ note: t.value });
      else if (t.dataset.cartAttr) { var attrs = {}; attrs[t.dataset.cartAttr] = t.value; update({ attributes: attrs }); }
    }, 500);
    drawer.addEventListener('input', function (e) {
      var t = e.target;
      if (t.tagName === 'TEXTAREA' && (t.dataset.cartAttr || t.hasAttribute('data-cart-note'))) saveText(t);
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });

    // After an add anywhere on the page the drawer opens with the fresh
    // section from the add response when it carried one, else re-fetched.
    document.addEventListener('xred:cart:added', function (e) {
      var d = e.detail;
      if (d && d.sections && d.sections['cart-drawer']) { swap(d.sections['cart-drawer']); open(); }
      else refresh(open);
    });
  }
  boot();
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
